import React, {useMemo, useState} from "react";
import {useParams} from "react-router-dom";
import useApi from "../../hooks/useApi";
import {AptStatusIcon, HeartIcon, LockIcon, PdfIcon, PresentationIcon} from "../../components/Public/markup/icons";
import AddPresenatation from "../../components/AddPresentation";
import SubmitButton from "../../components/SubmitButton";
import {getUrl} from "../../api";
import Preloader from "../../components/Preloader";
import InfoCard from "../../components/Public/markup/detail/InfoCard";
import Button from "../../components/core/Button";
import {useModal} from "react-modal-hook";
import PanModal from "../../components/core/PanModal";
import ContactsModal from "../../components/Public/markup/detail/ContactsModal";
import {useMapModal} from "../../hooks/useMapModal";
import useMedia from "../../hooks/useMedia";
import {ZoomIcon} from "../../components/core/SwiperSlider/icons";
import {PhotoPopup} from "../../components/Viewer/PhotoSlider";
import {PhotoSwipe} from "react-photoswipe";
import ErrorReport from "../../components/Apartment/NewAppartment/errorReport";
import ('./index.scss')

const ViewingPage = () => {

  const { id, city } = useParams()

  const [filePath, setfilePath] = useState(false)

  const { data: {
    actionInfo,
    apartmentInfo,
    roomType,
    squareTotal,
    status,
    presentation,
    xmlId,
    planLarge,
    priceInfo,
    meterPriceInfo,
    contacts,
    bookingLink,
    blockParamsInfo,
    block,
    schedule,
    title
  },
    errors,
    isLoading,
    inFavorite,
    isFavoriteLoading,
    toggleFavorite,
    send,
    isSending,
    fixationLink
  } = useApi({
    payload: ["panpartner:block.detail.ajax", "getParkingDetail", { id, city}],
    favoritesParams: {
      city,
      id,
      type: 'parking',
    },
    favoritePath: 'favorite',
  })


  const [openErrorsModal, closeErrorsModal] = useModal(
    () => (
      <PanModal title={'Сообщить об ошибке'} closeModal={closeErrorsModal} isSmall>
        <ErrorReport id={id} city={city} type='parking'/>
      </PanModal>
    ),
    [],
  );

  const renderPresentations = ({ fetching, finish, link, handleSend }) => {
    return <SubmitButton
      type="button"
      className="sf__elem-btn button link"
      isLoading={fetching}
      onClick={finish ? () => window.open(link) : handleSend}
    >
      <PresentationIcon />
      {finish || presentation?.id ? "К презентации" : "В презентации"}
    </SubmitButton>
  }
  const renderPdf = ({ fetching, finish, resp, handleSend }) => {
    return <SubmitButton
      type="button"
      className="sf__elem-btn button link"
      isLoading={fetching}
      onClick={filePath ? () => window.open(filePath) : () => handleSend().then(resp => {
        window.open(getUrl(resp?.filePath))
        setfilePath(getUrl(resp?.filePath))
      })}
    >
      <PdfIcon />
      {!isTablet && 'Скачать PDF'}
    </SubmitButton>
  }

  const cols = [
    {
      title: 'Цена при 100% оплате',
      value: priceInfo?.value,
    },
    {
      title: 'Цена за кв. метр',
      value: meterPriceInfo?.value,
    },
  ];

  const [openContactsModal, closeContactsModal] = useModal(
    () => (
      <PanModal title={'Контакты'} closeModal={closeContactsModal} isSmall>
        <ContactsModal
          contacts={contacts}
          schedule={schedule}
          params={{
            city
          }}
        />
      </PanModal>
    ),
    [contacts],
  );

  const isLaptop = useMedia("isLaptop");
  const isTablet = useMedia("isTablet");

  const [openMapModal, closeMapModal] = useMapModal({
    cords: block?.coordinates,
    mapCenter: block?.coordinates,
  })

  const [openGallery, setOpenGallery] = useState(false);
  let items = [
    {
      src: 'http://lorempixel.com/1200/900/sports/1',
      w: 1200,
      h: 900,
      title: 'Image 1'
    },
    {
      src: 'http://lorempixel.com/1200/900/sports/2',
      w: 1200,
      h: 900,
      title: 'Image 2'
    }
  ];

  if (isLoading) return <Preloader loading/>
  return (
    <div className="sf wrapper">
      <div className="common-header common-header_with-details">
        <div className="common-header__title" style={{alignItems: 'center'}}>
          <h3 className="common-title">
            {title}
          </h3>
          <div className={`label-item-status label label_${status?.color}`}>
            <AptStatusIcon/>
            {status?.name}
          </div>
        </div>
      </div>
      <div className="sf__detail-bar">
        {blockParamsInfo[0] &&
          <a href={blockParamsInfo[0]?.link} target="_blank" className="link link_color-red">{blockParamsInfo[0]?.value}</a>
        }
        {blockParamsInfo[1] &&
        <p className="text sf__detail-descr sf__detail-descr_center">{blockParamsInfo[1]?.value}</p>
        }
        {
         !!block?.coordinates?.length &&
          <span className="link link_color-red" onClick={openMapModal}>На карте</span>
        }

      </div>

      <div className="apt-modal__header-second" style={{position: 'relative'}}>
        <div className="sf sf--apt-modal">
          <div className="link error-report-link"  style={{marginTop: 0}} onClick={openErrorsModal}>
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.0394 8.76875C19.6737 8.38719 19.2959 7.99344 19.1441 7.62687C19.0034 7.28656 18.9959 6.78312 18.9875 6.25062C18.9744 5.37125 18.9594 4.37563 18.2919 3.70813C17.6244 3.04063 16.625 3.02562 15.7494 3.0125C15.2169 3.00406 14.7181 2.99656 14.3731 2.85594C14.0066 2.70406 13.6128 2.32625 13.2313 1.96062C12.6088 1.36437 11.9038 0.6875 11 0.6875C10.0962 0.6875 9.39125 1.36437 8.76875 1.96062C8.38719 2.32625 7.99344 2.70406 7.62687 2.85594C7.28656 2.99656 6.78312 3.00406 6.25062 3.0125C5.37125 3.02562 4.37563 3.04063 3.70813 3.70813C3.04063 4.37563 3.02562 5.375 3.0125 6.25062C3.00406 6.78312 2.99656 7.28187 2.85594 7.62687C2.70406 7.99344 2.32625 8.38719 1.96062 8.76875C1.36437 9.39125 0.6875 10.0962 0.6875 11C0.6875 11.9038 1.36437 12.6088 1.96062 13.2313C2.32625 13.6128 2.70406 14.0066 2.85594 14.3731C2.99656 14.7134 3.00406 15.2169 3.0125 15.7494C3.02562 16.6288 3.04063 17.6244 3.70813 18.2919C4.37563 18.9594 5.375 18.9744 6.25062 18.9875C6.78312 18.9959 7.28187 19.0034 7.62687 19.1441C7.99344 19.2959 8.38719 19.6737 8.76875 20.0394C9.39125 20.6356 10.0962 21.3125 11 21.3125C11.9038 21.3125 12.6088 20.6356 13.2313 20.0394C13.6128 19.6737 14.0066 19.2959 14.3731 19.1441C14.7134 19.0034 15.2169 18.9959 15.7494 18.9875C16.6288 18.9744 17.6244 18.9594 18.2919 18.2919C18.9594 17.6244 18.9744 16.6288 18.9875 15.7494C18.9959 15.2169 19.0034 14.7181 19.1441 14.3731C19.2959 14.0066 19.6737 13.6128 20.0394 13.2313C20.6356 12.6088 21.3125 11.9038 21.3125 11C21.3125 10.0962 20.6356 9.39125 20.0394 8.76875ZM19.2275 12.4531C18.7897 12.9087 18.3369 13.3812 18.1025 13.9437C17.8794 14.4819 17.87 15.1175 17.8606 15.7325C17.8503 16.43 17.8391 17.1519 17.495 17.4969C17.1509 17.8419 16.4281 17.8522 15.7306 17.8625C15.1156 17.8719 14.48 17.8813 13.9419 18.1044C13.3794 18.3369 12.9106 18.7897 12.4503 19.2294C11.9581 19.6981 11.4491 20.1894 10.9981 20.1894C10.5472 20.1894 10.0381 19.7009 9.545 19.2294C9.08938 18.7916 8.61688 18.3387 8.05438 18.1044C7.51625 17.8813 6.88062 17.8719 6.26562 17.8625C5.56812 17.8522 4.84625 17.8409 4.50125 17.4969C4.15625 17.1528 4.14594 16.43 4.13562 15.7325C4.12625 15.1175 4.11688 14.4819 3.89375 13.9437C3.66125 13.3812 3.20844 12.9125 2.76875 12.4522C2.30094 11.96 1.8125 11.4509 1.8125 11C1.8125 10.5491 2.30094 10.04 2.7725 9.54688C3.21031 9.09125 3.66313 8.61875 3.8975 8.05625C4.12063 7.51813 4.13 6.8825 4.13937 6.2675C4.14969 5.57 4.16094 4.84812 4.505 4.50313C4.84906 4.15813 5.57188 4.14781 6.26937 4.1375C6.88438 4.12812 7.52 4.11875 8.05813 3.89563C8.62063 3.66313 9.08937 3.21031 9.54969 2.77063C10.04 2.30094 10.5491 1.8125 11 1.8125C11.4509 1.8125 11.96 2.30094 12.4531 2.7725C12.9087 3.21031 13.3812 3.66313 13.9437 3.8975C14.4819 4.12063 15.1175 4.13 15.7325 4.13937C16.43 4.14969 17.1519 4.16094 17.4969 4.505C17.8419 4.84906 17.8522 5.57188 17.8625 6.26937C17.8719 6.88438 17.8813 7.52 18.1044 8.05813C18.3369 8.62063 18.7897 9.08937 19.2294 9.54969C19.6981 10.0419 20.1894 10.5509 20.1894 11.0019C20.1894 11.4528 19.6991 11.96 19.2275 12.4531ZM10.4375 11.75V6.5C10.4375 6.35082 10.4968 6.20774 10.6023 6.10225C10.7077 5.99676 10.8508 5.9375 11 5.9375C11.1492 5.9375 11.2923 5.99676 11.3977 6.10225C11.5032 6.20774 11.5625 6.35082 11.5625 6.5V11.75C11.5625 11.8992 11.5032 12.0423 11.3977 12.1477C11.2923 12.2532 11.1492 12.3125 11 12.3125C10.8508 12.3125 10.7077 12.2532 10.6023 12.1477C10.4968 12.0423 10.4375 11.8992 10.4375 11.75ZM11.9375 15.125C11.9375 15.3104 11.8825 15.4917 11.7795 15.6458C11.6765 15.8 11.5301 15.9202 11.3588 15.9911C11.1875 16.0621 10.999 16.0807 10.8171 16.0445C10.6352 16.0083 10.4682 15.919 10.3371 15.7879C10.206 15.6568 10.1167 15.4898 10.0805 15.3079C10.0443 15.126 10.0629 14.9375 10.1339 14.7662C10.2048 14.5949 10.325 14.4485 10.4792 14.3455C10.6333 14.2425 10.8146 14.1875 11 14.1875C11.2486 14.1875 11.4871 14.2863 11.6629 14.4621C11.8387 14.6379 11.9375 14.8764 11.9375 15.125Z" fill="#FF2D23"/></svg>
            Сообщить об ошибке
          </div>
          <div className="sf__elems" style={{marginTop: 0}}>
            <button
              type="button"
              className="sf__elem-btn button link"
              onClick={() => !isFavoriteLoading && toggleFavorite()}
              style={{width: 192}}
            >
              <HeartIcon isActive={inFavorite} />
              {inFavorite ? 'Убрать из избранного' : 'Добавить в избранное'}
            </button>
            <AddPresenatation
              type={'parking'}
              id={xmlId}
              city={city}
              presentation={presentation}
              render={renderPresentations}
            />
            <AddPresenatation
              type={'parking'}
              id={xmlId}
              city={city}
              method="getPdf"
              render={renderPdf}
            />
            {!!fixationLink && <button
              type="button"
              className="sf__elem-btn button link"
              onClick={() => window.open(fixationLink)}
            >
              <LockIcon />
              {!isLaptop && 'Зафиксировать клиента'}
            </button>}
          </div>
        </div>

      </div>

      <div className="sf">
        <div className="sf__detail-row sf__detail-row--common-page">
          <div className="sf__detail-col" style={{position: 'relative'}}>
            <img className="parking-img" src={getUrl(planLarge?.src)} alt=""/>
            <Button
              buttonType="clean"
              addClass="swiper-zoom"
              onClick={() => setOpenGallery(true)}
            >
              <ZoomIcon/>
            </Button>

          </div>
          <div className="sf__detail-col">
            <InfoCard items={apartmentInfo} cols={cols}/>

            <section className="sf__section">
              {!!bookingLink &&<Button buttonType="primary" isFull onClick={()=>window.open(bookingLink)}>
                Забронировать
              </Button>}
              <SubmitButton
                type="button"
                className="btn h6 btn_line btn_full"
                onClick={openContactsModal}
              >
                Контакты
              </SubmitButton>
            </section>


          </div>
        </div>
      </div>

      <PhotoSwipe
        isOpen={openGallery}
        items={[{ src: getUrl(planLarge?.src), w: 1200, h: 900, }]}
        onClose={() => setOpenGallery(false)}
        options={{
          closeOnScroll: false,
          closeOnVerticalDrag: false,
          history: false,
          maxSpreadZoom: 4,
          getDoubleTapZoom: (isMouseClick, item) => {
            if (isMouseClick) {
              return 1.5;

            } else {
              return item.initialZoomLevel < 0.7 ? 1 : 1.5;
            }
          }
        }}
      />
    </div>
  )
}

export default ViewingPage

